import pages from '@/enums/pages.json';
import Controls from '@/components/controls/Controls.vue';

export default {
  name: 'Menu',
  components: {
    Controls
  },
  updated() {
    if (this.isSubMenu) {
      this.setNavigationRoute();
    }
  },
  computed: {
    isSubMenu() {
      return this.path !== pages.menu;
    }
  },
  methods: {
    setNavigationRoute() {
      this.$store.commit(this.navigationRoute);
    }
  },
  props: {
    path: String,
    navigationRoute: String,
    fromRoute: {
      type: String,
      default: '/'
    },
    menuItems: Array
  }
};
